import script from "./AiAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./AiAssistant.vue?vue&type=script&setup=true&lang=js"

import "./AiAssistant.vue?vue&type=style&index=0&id=0fbe8777&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fbe8777"]])

export default __exports__